// extracted by mini-css-extract-plugin
export default {"tableStyles":"table_tableStyles__cSmYS","headerStyles":"table_headerStyles__IPRPT","rowStyles":"table_rowStyles__M99fX","cellStyles":"table_cellStyles__KgvQp"};